module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_referidos_seguimiento.ef243d28.svg";